export const matches = [
  {
    destination: [
      "https://ad.doubleclick.net/ddm/clk/525212197;332624538;f?https://www.compass.it/fissa-appuntamento/codice-fiscale?prodotto=01&utm_source=SPINUP&utm_medium=CPL&utm_content=Dem_WL&utm_campaign=FA_LP&mediacode=9038&spinupParentURL=https%3A%2F%2Fc-dem.netlify.app%2F",
    ],
    match: {
      region: [
        "abruzzo",
        "basilicata",
        "calabria",
        "campania",
        "emiliaromagna",
        "fvg",
        "lazio",
        "liguria",
        "lombardia",
        "marche",
        "molise",
        "piemonte",
        "puglia",
        "sardegna",
        "sicilia",
        "toscana",
        "trentino",
        "umbria",
        "valledaosta",
        "veneto",
      ],
      category: ["iva"],
    },
  },
  {
    destination: ["https://www.onlinecessionequinto.com/signorprestito"],
    match: {
      region: [
        "abruzzo",
        "basilicata",
        "calabria",
        "campania",
        "emiliaromagna",
        "fvg",
        "lazio",
        "liguria",
        "lombardia",
        "marche",
        "molise",
        "piemonte",
        "puglia",
        "sardegna",
        "sicilia",
        "toscana",
        "trentino",
        "umbria",
        "valledaosta",
        "veneto"
      ],
      category: ["public_employee", "military", "private_employee", "retired"],
    },
  },
  {
    destination: ["https://www.oraquinto.com/fincontinuo"],
    match: {
      region: [],
      category: [],
    },
  },
  {
    destination: ["https://www.oraquinto.com/affida"],
    match: {
      region: [],
      category: [],
    },
  },
  {
    destination: ["https://www.onlinecessionequinto.com/dynamica_retail"],
    match: {
      region: [],
      category: [],
    },
  },
  {
    destination: ["https://www.oraquinto.com/banca-races"],
    match: {
      region: [],
      category: [],
    },
  },
  {
    destination: ["https://www.onlinecessionequinto.com/iblbanca"],
    match: {
      region: [],
      category: [],
    },
  },
  {
    destination: ["https://www.onlinecessionequinto.com/mce-finance"],
    match: {
      region: [],
      category: [],
    },
  },
  {
    destination: ["https://www.oraquinto.com/sigla"],
    match: {
      region: [],
      category: [],
    },
  },
  {
    destination: ["https://www.oraquinto.com/prestito"],
    match: {
      region: [],
      category: [],
    },
  },
  {
    destination: ["https://www.onlinecessionequinto.com/avd-finance"],
    match: {
      region: [],
      category: [],
    },
  },
];

export const fallbackUrl = null;
